
export const ChatDownArrowIcon = (props) => {
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
<g clip-path="url(#clip0_443_23241)">
<path d="M12 1.67593C11.9328 1.89132 11.7801 2.04301 11.6243 2.19469C9.92294 3.88142 8.22463 5.56815 6.52938 7.25488C6.32168 7.46118 6.08343 7.55825 5.79936 7.46421C5.69245 7.42781 5.5886 7.35803 5.50918 7.27915C3.74368 5.53175 1.98123 3.78131 0.221835 2.03087C-0.0744525 1.7366 -0.0713969 1.35436 0.215727 1.06009C0.350124 0.92054 0.487576 0.78099 0.634192 0.653575C0.884662 0.441217 1.22982 0.453351 1.48029 0.66571C1.52 0.69908 1.5536 0.735485 1.59025 0.768855C3.02281 2.19166 4.45843 3.61446 5.89099 5.04029C5.92459 5.07366 5.95208 5.1131 6.03455 5.17377C6.05594 5.1313 6.07121 5.08276 6.10175 5.05243C7.54653 3.61446 8.99437 2.17952 10.4422 0.741552C10.711 0.474588 11.0836 0.419981 11.3372 0.641441C11.5968 0.865934 11.8778 1.07829 12 1.41807C12 1.50604 12 1.59099 12 1.67593Z" fill="#5B5B5B"/>
</g>
<defs>
<clipPath id="clip0_443_23241">
<rect width="8" height="13" fill="white" transform="translate(13 0.5) rotate(90)"/>
</clipPath>
</defs>
</svg>)
}